import { RootState } from '../store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type GlobalState = {
    step: number;
    titleModal?: String;
    isMobile: Boolean;
    spinnerLoading: String[];
    loadingHome: Boolean;
    taffiStoreId?: string;
    showAuthPopup: Boolean;
    showBottomNavigationBar: Boolean;
    loaderStyles: any;
    taffiEnableEngagingSlider: Boolean;
};
export const initialState: GlobalState = {
    step: 1,
    titleModal: '',
    isMobile: false,
    spinnerLoading: [],
    loadingHome: false,
    taffiStoreId: '',
    showAuthPopup: false,
    showBottomNavigationBar: false,
    loaderStyles: [],
    taffiEnableEngagingSlider: false,
};
// Action =====================================================
const globalSlice = createSlice({
    name: 'global',
    initialState,
    reducers: {
        nextStep(state, action: PayloadAction<number>) {
            state.step = action.payload;
        },
        preStep(state, action: PayloadAction<number>) {
            state.step = action.payload;
        },
        setTitle: (state, action) => {
            state.titleModal = action.payload;
        },
        deviceMobile: (state, action) => {
            state.isMobile = action.payload;
        },
        setSpinnerLoading: (state, action) => {
            state.spinnerLoading = action.payload;
        },
        setLoadingHome: (state, action) => {
            state.loadingHome = action.payload;
        },
        setTaffiStoreId: (state, action: PayloadAction<string>) => {
            state.taffiStoreId = action.payload;
        },
        setShowAuthPopup: (state, action: PayloadAction<boolean>) => {
            state.showAuthPopup = action.payload;
        },
        setBottomNavigationBar: (state, action: PayloadAction<boolean>) => {
            state.showBottomNavigationBar = action.payload;
        },
        setLoaderStyles: (state, action: any) => {
            state.loaderStyles = action.payload;
        },
        setTaffiEnableEngagingSlider: (state, action: any) => {
            state.taffiEnableEngagingSlider = action.payload;
        },
    },
});

// Selector =====================================================
export const globalActions = globalSlice.actions;
export const selectStep = (state: RootState) => state.global.step;
export const setTitleModal = (state: RootState) => state.global.titleModal;
// Reducer=====================================================
const globalReducer = globalSlice.reducer;
export default globalReducer;
